import { render, staticRenderFns } from "./UpdateRecordDetail.vue?vue&type=template&id=2d54535e&scoped=true&"
import script from "./UpdateRecordDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.css?vue&type=style&index=0&id=2d54535e&scoped=true&lang=css&"
import style1 from "./UpdateRecordDetail.vue?vue&type=style&index=1&id=2d54535e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54535e",
  null
  
)

export default component.exports